<template>
  <div class="login">
    <div class="login__aside">
      <div class="login__brand">
        <img
          alt="Vadimm"
          src="/vadimm-logo.svg"
          width="30">
        <span>vadimm<b>.</b></span>
      </div>
      <div>
        <h1 class="login__headline">
          Administration
        </h1>
        <p class="login__tagline">
          Comptes, abonnements, ventes et facturation de la plateforme.
        </p>
      </div>
      <span class="login__footer">Accès réservé aux superadmins</span>
    </div>

    <div class="login__main">
      <div class="login__form">
        <h2 class="login__title">
          Connexion
        </h2>
        <p class="login__subtitle">
          Connectez-vous avec votre compte Vadimm.
        </p>
        <!-- la connexion se fait sur l'environnement choisi : il doit être visible et modifiable avant de se connecter -->
        <div class="login__env">
          <env-switch />
        </div>
        <ValidationObserver
          ref="obs"
          v-slot="{ handleSubmit }">
          <v-form @submit.prevent="handleSubmit(onSubmit)">
            <label
              class="login__label"
              for="login-email">Email</label>
            <validation-input
              id="login-email"
              v-model="email"
              rules="required|email"
              name="Email"
              placeholder="prenom@vadimm.fr"
              outlined
              dense
              autocomplete="username" />
            <label
              class="login__label"
              for="login-password">Mot de passe</label>
            <validation-input
              id="login-password"
              v-model="password"
              rules="required|min:6"
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
              name="Mot de passe"
              placeholder="••••••••"
              outlined
              dense
              autocomplete="current-password"
              @click:append="showPassword = !showPassword" />

            <v-btn
              :loading="loading"
              type="submit"
              color="primary"
              depressed
              block
              large>
              Se connecter
            </v-btn>
          </v-form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
  import EnvSwitch from '../components/EnvSwitch'

  export default {
    name: 'Login',
    components: { EnvSwitch },
    data () {
      return {
        email: null,
        password: null,
        showPassword: false,
        loading: false
      }
    },
    methods: {
      async onSubmit () {
        const payload = {
          email: this.email,
          password: this.password
        }
        this.loading = true
        try {
          let { data } = await this.$api.login(payload)
          this.$store.commit('setToken', data.access_token)
        } catch (e) {
          this.$awn.alert('Identifiants incorrects')
        } finally {
          this.loading = false
        }
      }
    }
  }
</script>

<style scoped>
  .login {
    display: flex;
    min-height: 100vh;
  }
  .login__aside {
    width: 42%;
    max-width: 560px;
    padding: 40px 48px;
    margin: 16px;
    border-radius: 24px;
    background: radial-gradient(600px 400px at 20% 110%, #e9e3ff 0%, rgba(233, 227, 255, 0) 70%), radial-gradient(500px 300px at 90% 0%, #f3efff 0%, rgba(243, 239, 255, 0) 70%), #fafafa;
    color: #111113;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .login__brand {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 22px;
    font-weight: 800;
    letter-spacing: -0.5px;
  }
  .login__brand b {
    color: #7c6cf2;
  }
  .login__headline {
    font-size: 44px;
    font-weight: 700;
    letter-spacing: -1.4px;
    line-height: 1.1;
    margin-bottom: 12px;
  }
  .login__tagline {
    font-size: 16px;
    color: #52525b;
    max-width: 360px;
  }
  .login__footer {
    font-size: 13px;
    color: #7a7a85;
  }
  .login__main {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: white;
  }
  .login__form {
    width: 100%;
    max-width: 380px;
  }
  .login__title {
    font-size: 28px;
    font-weight: 700;
    letter-spacing: -0.8px;
  }
  .login__subtitle {
    color: #6b7280;
    margin: 4px 0 24px;
  }
  .login__env {
    margin: -8px 0 20px;
  }
  .login__label {
    display: block;
    margin-bottom: 6px;
    font-size: 13px;
    font-weight: 600;
  }
  @media (max-width: 800px) {
    .login__aside {
      display: none;
    }
  }
</style>
